import { Unit } from "types/landlord/address";
import { ListingSection } from "./ListingSection";
import { GeneralSection } from "./GeneralSection";
import { LockboxSection } from "./LockboxSection";
import { PlanSection } from "./PlanSection";
import { AmenitiesSection } from "./AmenitiesSection";
import { PhotosSection } from "./PhotosSection";
import { Show } from "shared/components";
import { RentalInfoSection } from "shared/app/RentalInfoSection";
import { useAuthContext } from "providers/Auth";

interface UnitDetailsProps {
  unit?: Unit;
}

export const UnitDetails = ({ unit }: UnitDetailsProps) => {
  const { type } = useAuthContext();

  if (!unit) return null;

  return (
    <div>
      <div className="space-y-4 max-w-[822px] w-full">
        <ListingSection
          propertyKind={unit.property.kind}
          propertyId={unit.property.id}
          unit={unit}
        />
        <GeneralSection unit={unit} />
        {unit.property.prescreening_template?.showing_type ===
          "self_guided" && (
          <LockboxSection unit={unit} propertyId={unit.property.id} />
        )}
        <RentalInfoSection unit={unit} />
        <Show if={unit.property.kind || type.isPmsListingSyncEnabled}>
          <PlanSection unit={unit} />
          <AmenitiesSection unit={unit} />
          <PhotosSection unit={unit} />
        </Show>
      </div>
    </div>
  );
};
